














































































































































































































































































































































































import {
  computed,
  defineComponent,
  reactive,
  Ref,
  ref,
  watch,
} from '@vue/composition-api';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';
import { useFormat } from 'vivat';
import draggable from 'vuedraggable';
import _ from 'lodash';
import PrettyCheck from 'pretty-checkbox-vue/check';

import VehicleObject from '@/components/DeliveryNote/VehicleObject.vue';
import DeliveryObject from '@/components/DeliveryNote/DeliveryObject.vue';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonModalWithDriverSelector from '@/components/DeliveryNote/CommonModalWithDriverSelector.vue';
import CommonModalWithDivideDelivery from '@/components/DeliveryNote/CommonModalWithDivideDelivery.vue';
import CommonModalWithDriverAbsenceEditor from '@/components/Driver/CommonModalWithDriverAbsenceEditor.vue';
import ViewDeliveryMarkerModal from '@/components/Delivery/ViewDeliveryMarkerModal.vue';
import CommonAreaCodeSelector from '@/components/Setting/CommonAreaCodeSelector.vue';

import getDeliveryNotesForArrange from '@/gql/deliveryNote/getDeliveryNotesForArrange.gql';
import createDeliveryNote from '@/gql/deliveryNote/createDeliveryNote.gql';
import updateDeliveryNote from '@/gql/deliveryNote/updateDeliveryNote.gql';
import deleteDeliveryNote from '@/gql/deliveryNote/deleteDeliveryNote.gql';

import useCreateDeliveryNote from '@/views/DeliveryNote/useCreateDeliveryNote';
import useDeliveryAreaCode from '@/useDeliveryAreaCode';
import useDelivery from '@/useDelivery';
import useDriverProfile from '@/useDriverProfile';
import useAuth from '@/useAuth';
import useDeliveryNoteStatus from '@/useDeliveryNoteStatus';

const NOW = useFormat.date().computerShortDate();
interface Vehicle {
  id: string;
  driver: { id: string };
}
interface DeliveryNote {
  id: number;
  vehicle: Vehicle[];
  deliveries: any[];
  status: string;
  driver: string;
  deliveryManCount: number;
  uniqueId: string;
  tempDeliveriesId?: number[];
  saved: boolean;
  editable?: boolean;
}
const basedDeliveryNote = {
  id: -1,
  driver: '',
  vehicle: [],
  deliveryManCount: 0,
  deliveries: [],
  status: 'PREPARE_TO_DELIVER',
  uniqueId: '',
  saved: false,
  editable: false,
  deliveryDate: NOW,
};

const CreateOrder = defineComponent({
  components: {
    draggable,
    DeliveryObject,
    VehicleObject,
    CommonModalWithPreset,
    CommonModalWithDriverSelector,
    CommonModalWithDivideDelivery,
    CommonModalWithDriverAbsenceEditor,
    ViewDeliveryMarkerModal,
    CommonAreaCodeSelector,
    PrettyCheck,
  },
  setup() {
    const YESTERDAY = useFormat.date().dayjs.subtract(1, 'day').format('YYYY-MM-DD');
    const LAST7DAY = useFormat.date().dayjs.subtract(7, 'day').format('YYYY-MM-DD');
    const filterDateRange = ref(NOW);
    const toCurrency = (number: string) => useFormat.number(number).currency();
    const displayDate = (date: string) => useFormat.date(date).displayFullThaiDate();
    const { translateDistanceType, farthestDeliveryDistanceIndex } = useDeliveryAreaCode();
    const { sumPackagesPrice } = useDelivery();
    const { deliveriesStatusToDeliveryNoteStatus } = useDeliveryNoteStatus();
    const { mapLastSevenDaysDeliveryNotes } = useDriverProfile();
    const {
      filterVehicleDropdown,
      filterVehicleValues,
      search,
      deliveryNameSearchHandler,
      deliveryFilterHandler,
      sortDeliveryDisplay,
      sortDeliveryList,
      deliverySortHandler,
      vehicleNameSearchHandler,
      vehicles,
      vehiclePaginatorInfo,
      vehiclesLoading,
      vehiclesPage,
      vehicleStaticTotal,
      vehicleSortHandler,
      deliveries,
      deliveryPaginatorInfo,
      deliveriesLoading,
      deliveriesPage,
      deliveryStaticTotal,
      loading,
      mostStableTotalItem,
      countResend,
    } = useCreateDeliveryNote(filterDateRange);
    const { me } = useAuth();

    const deliveryNotes: Ref<DeliveryNote[]> = ref([{
      id: -1,
      driver: '',
      vehicle: [],
      deliveryManCount: 0,
      deliveries: [],
      status: 'PREPARE_TO_DELIVER',
      uniqueId: '',
      saved: false,
      editable: true,
      deliveryDate: NOW,
    }]);
    const tempDelivery: Ref<any[]> = ref([]);
    function moveTempDeliveryToDeliveryNote(dnIndex: number) {
      deliveryNotes.value[dnIndex].deliveries.push(...tempDelivery.value);
      tempDelivery.value = [];
    }

    const alreadyArrangeItem = computed(() => {
      let delivery = 0;
      const vehicleIds: number[] = [];
      deliveryNotes.value.forEach((dn: any) => {
        if (dn.vehicle.length > 0) vehicleIds.push(dn.vehicle[0].id);
        dn.deliveries.forEach(() => {
          delivery += 1;
        });
      });

      return {
        vehicle: vehicleIds.length,
        delivery,
        vehicleIds,
      };
    });

    // Get DeliveryNote
    const { result: getDeliveryNotesResult, loading: deliveryNotesLoading } = useQuery(getDeliveryNotesForArrange, computed(() => ({
      filterDeliveryDateBetween: { from: `${filterDateRange.value}`, to: `${filterDateRange.value}` },
      filterDriverDeliveryNotesCreatedAtBetween: { from: `${LAST7DAY} 00:00:00`, to: `${YESTERDAY} 23:59:59` },
    })), () => ({ fetchPolicy: 'network-only' }));
    const deliveryNoteResult = useResult(getDeliveryNotesResult, [], (data: any) => data.deliveryNotes.data);
    watch(() => getDeliveryNotesResult.value, () => {
      if (!deliveryNotesLoading.value) {
        if (deliveryNoteResult.value.length === 0) deliveryNotes.value = [basedDeliveryNote];
        else {
          deliveryNotes.value = deliveryNoteResult.value.map((deliveryNote: any) => ({
            id: deliveryNote.id,
            ...deliveryNote,
            vehicle: [{
              ...deliveryNote.vehicle,
              driver: {
                id: deliveryNote.driver.id,
                name: deliveryNote.driver.name,
                avatarUrl: deliveryNote.driver.avatarUrl,
                lastSevenDay: mapLastSevenDaysDeliveryNotes(deliveryNote.driver.paginatedDeliveryNotes.data),
              },
            }],
            deliveries: [
              ...deliveryNote.deliveries.map((delivery: any) => ({
                ...delivery,
                packagesPrice: sumPackagesPrice(delivery.packages),
              })),
              ...deliveryNote.loggedDeliveries.map((delivery: any) => ({
                ...delivery,
                packagesPrice: sumPackagesPrice(delivery.packages),
              })),
            ],
            tempDeliveriesId: deliveryNote.deliveries.map((delivery: any) => (delivery.id)),
            saved: true,
            editable: deliveryNote.status !== 'SUCCESS',
          }));
        }
      }
    });

    // Scroll on sidebar Handler
    function scrollDeliveriesAreaHandler(visible: any) {
      if (!(deliveriesLoading.value) && deliveryPaginatorInfo.value.lastPage > deliveriesPage.value && visible) {
        deliveriesPage.value += 1;
      }
    }
    function scrollVehiclesAreaHandler(visible: any) {
      if (!vehiclesLoading.value && vehiclePaginatorInfo.value.lastPage > vehiclesPage.value && visible) {
        vehiclesPage.value += 1;
      }
    }

    const deliveryNotesInformation = computed(() => {
      const singleDeliveryNotesInfo: { weight: number; price: number; distance: string | null; deliveryAreaCode: string | null; packagesPrice: number; area?: any; status: string }[] = [];
      let totalArrangeDelivery = 0;
      deliveryNotes.value.forEach((deliveryNote: any) => {
        let weight = 0;
        let price = 0;
        let packagesPrice = 0;
        const distanceArr: string[] = [];
        const deliveryAreaCodeArr: string[] = [];
        totalArrangeDelivery += deliveryNote.deliveries.length;
        deliveryNote.deliveries.forEach((delivery: any) => {
          weight += delivery.totalWeight;
          price += delivery.deliveryFee;
          packagesPrice += delivery.packagesPrice;
          distanceArr.push(delivery.area?.distanceType || '');
          deliveryAreaCodeArr.push(`${delivery.area?.code || ''} ${translateDistanceType(delivery.area?.distanceType)}`);
        });
        const distanceIndex = farthestDeliveryDistanceIndex(distanceArr);
        singleDeliveryNotesInfo.push({
          weight,
          price,
          distance: distanceArr[distanceIndex as number],
          deliveryAreaCode: deliveryAreaCodeArr[distanceIndex as number],
          packagesPrice,
          area: deliveryNote.deliveries[distanceIndex as number]?.area,
          status: deliveriesStatusToDeliveryNoteStatus(deliveryNote.deliveries),
        });
      });
      return {
        deliveryNote: singleDeliveryNotesInfo,
        deliveryNotes: totalArrangeDelivery,
      };
    });

    const disabledSortable = reactive({
      delivery: false,
      vehicle: false,
      deliveryNote: false,
      placeholderVehicle: false,
    });
    const sortableGroups = computed(() => Object.keys(disabledSortable));
    function chooseObjectHandler(allowKey: string) {
      sortableGroups.value.forEach((key) => {
        (disabledSortable as any)[key] = true;
      });
      (disabledSortable as any)[allowKey] = false;
    }
    function unChooseObjectHandler(allowKey: string) {
      sortableGroups.value.forEach((key) => {
        (disabledSortable as any)[key] = false;
      });
    }
    const temporaryDraggedVehicle: Ref<Vehicle> = ref({ id: -1 });
    function addDeliveryNote() {
      deliveryNotes.value.splice(0, 0, {
        id: -1,
        vehicle: [],
        driver: '',
        deliveryManCount: 0,
        deliveries: [],
        status: 'PREPARE_TO_DELIVER',
        uniqueId: '',
        saved: false,
        editable: true,
      });
    }

    // Use to computed Arrange Panel size
    const showDeliveryList = ref(true);
    const showVehicleList = ref(true);
    const showSummaryPanel = ref(true);
    const mainPanelWidth = computed(() => {
      let width = 8;
      if (showDeliveryList.value) width += 18.8;
      if (showVehicleList.value) width += 18.8;
      if (showDeliveryList.value && showVehicleList.value) width -= 0.1;
      return `${width}rem`;
    });
    const deliveriesDropzoneHeight = computed(() => {
      let height = 333;
      if (showSummaryPanel.value) height += 122;
      return `${height}`;
    });

    // Use to toggle Vehicle Selector modal
    const driverSelectorVariable = reactive({
      callFrom: -1,
      index: -1,
    });
    const driverSelectorModal = ref(null);
    function pendingSelectDriver(callFrom: number, index: number) {
      driverSelectorVariable.callFrom = callFrom;
      driverSelectorVariable.index = index;
      (driverSelectorModal.value as any).open();
    }

    function setDriverOnVehicle(driver: any) {
      if (driverSelectorVariable.callFrom === 0) { // 0 stand for Vehicle List
        vehicles.value[driverSelectorVariable.index].driver = driver;
      } else if (driverSelectorVariable.callFrom === 1) { // 1 stand for DeliveryNote List
        deliveryNotes.value[driverSelectorVariable.index].vehicle[0].driver = driver;
      }
    }

    // Handler DeliveryManCount
    function changeDeliveryManCount($event: number, index: number) { deliveryNotes.value[index].deliveryManCount = $event; }

    // Pending to save DeliveryNote
    const pendingToSaveIndex = ref(-1);
    const refetchQueries = ['getDeliveryNotes', 'getDeliveries', 'getVehicles', 'getMostStableTotalItem'];
    const createDeliveryNoteInput = computed(() => deliveryNotes.value.map((deliveryNote) => ({
      // status: deliveryNote.status,
      status: deliveryNotesInformation.value.deliveryNote[pendingToSaveIndex.value]?.status || deliveryNote.status,
      driver: { connect: parseInt(deliveryNote.vehicle[0]?.driver.id, 10) },
      vehicle: { connect: parseInt(deliveryNote.vehicle[0]?.id, 10) },
      deliveries: {
        update: deliveryNote.deliveries.map((delivery: { id: string }, index: number) => ({ id: parseInt(delivery.id, 10), order: index + 1 })),
        disconnect: deliveryNote.tempDeliveriesId?.filter((id: any) => deliveryNote.deliveries.map((delivery: { id: string }) => (parseInt(delivery.id, 10))).indexOf(parseInt(id, 10)) === -1),
      },
      deliveryManCount: deliveryNote.deliveryManCount,
      distanceType: pendingToSaveIndex.value > -1 ? deliveryNotesInformation.value.deliveryNote[pendingToSaveIndex.value].distance : 'NA',
      deliveryDate: filterDateRange.value,
      area: deliveryNotesInformation.value.deliveryNote[pendingToSaveIndex.value]?.area?.id ? { connect: deliveryNotesInformation.value.deliveryNote[pendingToSaveIndex.value].area?.id } : undefined,
    })));
    const createDeliveryNoteMutation = useMutation(createDeliveryNote, () => ({
      variables: {
        input: createDeliveryNoteInput.value[pendingToSaveIndex.value],
      },
      refetchQueries,
    }));
    const updateDeliveryNoteMutation = useMutation(updateDeliveryNote, () => ({
      variables: {
        id: deliveryNotes.value[pendingToSaveIndex.value].id,
        input: createDeliveryNoteInput.value[pendingToSaveIndex.value],
      },
      refetchQueries,
    }));

    // Error & Confirmation Modal
    function afterSaveDone(index: number) {
      deliveryNotes.value[index].saved = true;
      pendingToSaveIndex.value = -1;
    }
    const successCreateDeliveryNoteModal = ref(null);
    const errorCreateDeliveryNoteModal = ref(null);
    createDeliveryNoteMutation.onDone((result: any) => {
      deliveryNotes.value[pendingToSaveIndex.value].id = result.data.createDeliveryNote.id;
      deliveryNotes.value[pendingToSaveIndex.value].uniqueId = result.data.createDeliveryNote.uniqueId;
      afterSaveDone(pendingToSaveIndex.value);
      (successCreateDeliveryNoteModal.value as any).compose({ action: 'สร้าง', entity: 'รายการ สำเร็จ' });
    });
    updateDeliveryNoteMutation.onDone(() => {
      afterSaveDone(pendingToSaveIndex.value);
      (successCreateDeliveryNoteModal.value as any).compose({ action: 'บันทึก', entity: 'รายการ สำเร็จ' });
    });
    function mutationErrorHandler(mutationResponse: any) {
      let message = '';
      if (mutationResponse.extensions.reason === 'Could not find matching DriverPayout for this DeliveryNote') {
        let entity = 'คนขับ';
        if (mutationResponse.message === 'LOADER') entity = 'พนักงานยกของ';
        message = `โปรดตรวจเช็คค่าตอบแทน${entity} ให้ตรงกับรายการที่ท่านสร้าง`;
      }
      (errorCreateDeliveryNoteModal.value as any).compose({ body: message });
    }
    createDeliveryNoteMutation.onError((res: any) => {
      mutationErrorHandler(res);
    });
    updateDeliveryNoteMutation.onError((res: any) => {
      mutationErrorHandler(res);
    });
    function saveHandler(deliveryNoteIndex: number, allowToSave: boolean) {
      if (deliveryNotes.value[deliveryNoteIndex].saved) {
        deliveryNotes.value[deliveryNoteIndex].saved = false;
      } else if (allowToSave) {
        pendingToSaveIndex.value = deliveryNoteIndex;
        if (deliveryNotes.value[deliveryNoteIndex].id > -1) updateDeliveryNoteMutation.mutate();
        else createDeliveryNoteMutation.mutate();
      } else {
        (errorCreateDeliveryNoteModal.value as any).compose({ body: 'โปรดเลือกคนขับรถ' });
      }
    }

    // Divide Delivery stuff
    const pendingDivideDelivery: Ref<number> = ref(-1);
    const divideDeliveryModal = ref(null);
    function openDivideDeliveryModal($event: number) {
      pendingDivideDelivery.value = $event;
      (divideDeliveryModal.value as any).open();
    }

    // Use to render map modal
    const viewMapModal = ref(null);
    const mapMarkers: Ref<{ delivery: any; lat: number; lng: number; open: boolean }[]> = ref([]);
    function pendingToViewMap(deliveryNoteIndex: number) {
      mapMarkers.value = deliveryNotes.value[deliveryNoteIndex].deliveries.map((dv: any) => ({
        delivery: dv,
        open: false,
        lat: parseFloat(dv.lat) >= -90 && parseFloat(dv.lat) <= 90 ? parseFloat(dv.lat) : 0,
        lng: parseFloat(dv.long) >= -180 && parseFloat(dv.long) <= 180 ? parseFloat(dv.long) : 0,
      }));
      (viewMapModal.value as any).open();
    }

    // ==============================================
    // ===== Use to delete Delivery from system =====
    // ==============================================
    const refetchQueriesList = [
      'getDeliveryNotes', 'countDeliveryNote', 'getDeliveries', 'getDeliveryNotesForArrange', 'getVehicles',
    ];
    const deleteDeliveryNoteModal = ref(null);
    const deleteDeliveryNoteMutation = useMutation(deleteDeliveryNote, {
      refetchQueries: refetchQueriesList,
    });
    function deleteDeliveryNoteAction(deliveryId: number) {
      deleteDeliveryNoteMutation.mutate({
        id: deliveryId,
      });
    }
    function pendingDeleteDeliveryNote(deliveryNoteIndex: number) {
      if (deliveryNotes.value[deliveryNoteIndex].id > -1) {
        (deleteDeliveryNoteModal.value as any).compose({ action: 'ลบ', id: deliveryNotes.value[deliveryNoteIndex].id });
      } else deliveryNotes.value.splice(deliveryNoteIndex, 1);
    }

    const selectedDeliveries: Ref<number[]> = ref([]);
    const selectedDeliveriesObject: Ref<any[]> = ref([]);
    function selectAll() {
      if (deliveries.value.length === selectedDeliveries.value.length) {
        selectedDeliveries.value = [];
        selectedDeliveriesObject.value = [];
      } else {
        for (let i = 0; i < deliveries.value.length; i += 1) {
          selectedDeliveries.value.push(deliveries.value[i].id);
          selectedDeliveriesObject.value.push(deliveries.value[i]);
        }
      }
    }
    function selectDelivery(delivery: any) {
      const index = selectedDeliveries.value.indexOf(delivery.id);
      if (index > -1) {
        selectedDeliveries.value.splice(index, 1);
        selectedDeliveriesObject.value.splice(index, 1);
      } else {
        selectedDeliveries.value.push(delivery.id);
        selectedDeliveriesObject.value.push(delivery);
      }
    }
    function pasteDeliveryIntoDeliveryNote(dnIndex: number) {
      deliveryNotes.value[dnIndex].deliveries = [
        ...selectedDeliveriesObject.value,
        ...deliveryNotes.value[dnIndex].deliveries,
      ];
      deliveries.value = deliveries.value.filter((item: any) => selectedDeliveries.value.indexOf(item.id) === -1);
      selectedDeliveries.value = [];
      selectedDeliveriesObject.value = [];
    }

    return {
      toCurrency,
      displayDate,
      filterDateRange,

      search,
      deliveryNameSearchHandler,
      deliveryFilterHandler,
      deliverySortHandler,

      loading,

      deliveryNotes,
      createDeliveryNote,
      createDeliveryNoteMutation,

      vehicles,
      vehiclePaginatorInfo,
      vehicleStaticTotal,
      vehicleSortHandler,
      vehicleNameSearchHandler,
      filterVehicleValues,
      filterVehicleDropdown,

      tempDelivery,
      moveTempDeliveryToDeliveryNote,
      deliveries,
      deliveriesLoading,
      deliveryPaginatorInfo,
      deliveryStaticTotal,
      countResend,

      alreadyArrangeItem,
      mostStableTotalItem,

      createDeliveryNoteInput,

      successCreateDeliveryNoteModal,
      errorCreateDeliveryNoteModal,

      scrollDeliveriesAreaHandler,
      scrollVehiclesAreaHandler,

      sortDeliveryDisplay,
      sortDeliveryList,

      deliveryNotesInformation,

      disabledSortable,
      temporaryDraggedVehicle,
      chooseObjectHandler,
      unChooseObjectHandler,
      addDeliveryNote,

      mainPanelWidth,
      deliveriesDropzoneHeight,
      showVehicleList,
      showDeliveryList,
      showSummaryPanel,

      driverSelectorModal,
      pendingSelectDriver,
      setDriverOnVehicle,

      changeDeliveryManCount,

      saveHandler,

      divideDeliveryModal,
      pendingDivideDelivery,
      openDivideDeliveryModal,

      // use to view map on each DeliveryNote
      viewMapModal,
      mapMarkers,
      pendingToViewMap,

      deleteDeliveryNoteModal,
      deleteDeliveryNoteAction,
      pendingDeleteDeliveryNote,

      selectedDeliveries,
      selectAll,
      selectDelivery,
      pasteDeliveryIntoDeliveryNote,
    };
  },
});

export default CreateOrder;
